/**
 * Format seconds into human-readable time string
 * Following brand voice: direct, simple, no technical jargon
 * 
 * @param seconds - Number of seconds
 * @returns Human-readable time string (e.g., "30 seconds", "2 minutes", "1 hour")
 */
export function formatRetryTime(seconds: number): string {
  if (seconds < 60) {
    return `${seconds} ${seconds === 1 ? 'second' : 'seconds'}`;
  }
  
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  }
  
  const hours = Math.floor(minutes / 60);
  return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
}

